export const isSearchExecuted = (searchData) => searchData && searchData.execute > 0;
